export default __webpack_public_path__ + "static/media/Img0021.d80e2872.png";